import React from "react";
import { Outlet } from "react-router-dom";
import Grid from "@mui/material/Grid";
import { Typography } from "@mui/material";
import Link from '@mui/material/Link';
import { makeStyles } from '@material-ui/core/styles';
import { Box } from '@mui/system';
import booklast from  "../../assets/book_last.png"

const BookLastPage = (props) => {
    const classes = useStyles();
    return (
        <Box>
        {/* <Grid container  className={classes.paperContainer}>
            <Grid sx={{ textAlign: 'center', pt: 6 }}>
                 <img src={require('../../assets/WW_Full1.png')} width='40%' /> 
            </Grid>
            <Grid xs={12} sx={{ textAlign: 'center', }}>
                <Typography sx={{fontWeight: '500', color: '#EFEFEF',
                      '@media (min-width: 1636px)': {
                        fontSize: '1.4rem'
                      }}}>
                    204, Silicon Towers,
                </Typography>
                <Typography sx={{fontWeight: '500', color: '#EFEFEF',
                      '@media (min-width: 1636px)': {
                        fontSize: '1.4rem'
                      }}}>
                    Near Law Garden,
                </Typography>
                <Typography sx={{fontWeight: '500', color: '#EFEFEF',
                      '@media (min-width: 1636px)': {
                        fontSize: '1.4rem'
                      }}}>
                    Navrangpura,
                </Typography>
                <Typography sx={{fontWeight: '500', color: '#EFEFEF',
                      '@media (min-width: 1636px)': {
                        fontSize: '1.4rem'
                      }}}>
                    Ahmedabad - 380 009.
                </Typography>
                <Typography sx={{fontWeight: '500', color: '#EFEFEF',
                      '@media (min-width: 1636px)': {
                        fontSize: '1.4rem'
                      }}}>
                    Gujarat, India
                </Typography>
            </Grid>
            <Grid xs={12} sx={{ textAlign: 'center', fontWeight: '500', pt: 3 }}>
                <Link sx={{ color: '#EFEFEF',
                      '@media (min-width: 1636px)': {
                        fontSize: '1.4rem'
                      }}} href="https://www.wordsworthelt.com/" underline="none" target="_blank">
                    www.wordsworthelt.com
                </Link>
                <Typography sx={{ textDecoration: 'none' }}><a href="" sx={{ TextDecoderStream: 'none' }}></a></Typography>
            </Grid>
        </Grid> */}
        </Box>
    );
};
const useStyles = makeStyles({
    paperContainer: {
        backgroundImage: `url(${booklast})`,
        backgroundSize: 'cover',
        // background: 'linear-gradient(to bottom, rgba(30,87,153,1) 0%,rgba(19,49,117,1) 0%,rgba(58,84,175,1) 6%,rgba(58,84,175,1) 92%,rgba(19,49,117,1) 100%,rgba(125,185,232,1) 100%);',
        height: '70.5vh',
        // boxShadow: 'inset 0px 0px 20px 0px rgba(255,255,255,1)',

    }
})
export default BookLastPage;